export default function ProgressBarCtrl($scope, progressBar) {
  //this.status = progressBar.status;
  this.status = progressBar.items()
      .map(function (statuses) {
        return !!statuses.length;  //TRUE if there are any statuses
      });
}
